module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comp-agency-tree-detail"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n    选择门店\n    "), _c('span', {
    staticClass: "close",
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("✕")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "品牌："
    }
  }, [_c('a', {
    staticClass: "select-item",
    class: {
      active: _vm.form.brand === 'all'
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.handleSelectAllBrand
    }
  }, [_vm._v("全部")]), _vm._v(" "), _vm._l((_vm.brands), function(item) {
    return _c('a', {
      staticClass: "select-item",
      class: {
        active: item.id === _vm.form.brand
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.handleBrandClick(item)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "经营方式："
    }
  }, _vm._l((_vm.manageWays), function(item) {
    return _c('a', {
      staticClass: "select-item",
      class: {
        active: item.id === _vm.form.manageWay
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.handleWayClick(item)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  })), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "城市区域："
    }
  }, [_c('a', {
    staticClass: "select-item",
    class: {
      active: _vm.form.area === 'all'
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.handleSelectAllArea
    }
  }, [_vm._v("全部")]), _vm._v(" "), _vm._l((_vm.provinces), function(item, index) {
    return _c('a', {
      key: index,
      staticClass: "select-item",
      class: {
        active: item.active
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.handleSelectProv(item)
        }
      }
    }, [_vm._v("\n          " + _vm._s(((item.name) + "(" + (item.children.filter(function (item) {return item.active;}).length) + ")")))])
  }), _vm._v(" "), (this.form.area !== 'all') ? _c('div', {
    staticClass: "city-container"
  }, _vm._l((_vm.form.province.children), function(city, index) {
    return _c('a', {
      key: index,
      staticClass: "select-item",
      class: {
        active: city.active
      },
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          _vm.handleSelectCity(city)
        }
      }
    }, [_vm._v(_vm._s(city.name))])
  })) : _vm._e()], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "经营门店："
    }
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n            已选 " + _vm._s(this.selectList.length) + " 家\n            "), _c('span', {
    staticClass: "clear-btn",
    on: {
      "click": _vm.handleClear
    }
  }, [_vm._v("清空")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('AgencyTreeCore', {
    ref: "tree",
    attrs: {
      "checkable": _vm.checkable,
      "className": "detail",
      "content-height": 280,
      "has-show-more-btn": false,
      "treeData": _vm.treeData,
      "filter-node-method": _vm.handleFilterNode
    },
    on: {
      "checkAgencyLeaves": _vm.checkAgencyLeaves,
      "nodeClick": _vm.handleNodeClick,
      "filter": _vm.handleFilter
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "btn-area"
  }, [_c('el-button', {
    staticClass: "reset-btn",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('el-button', {
    staticClass: "save-btn",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v("确认")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cb18e6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui/AgencyTree/AgencyTreeDetail.vue
// module id = 181
// module chunks = 0